import * as React from 'react';
import AntTabs, { TabsProps as AntTabsProps, TabPaneProps } from 'antd/lib/tabs';

import styles from './Tabs.module.scss';
export interface TabsProps extends AntTabsProps {}

export class Tabs extends React.Component<TabsProps, {}> {
	static TabPane: React.ClassicComponentClass<TabPaneProps>;

	render() {
		return <AntTabs className={styles.tabs} {...this.props} />;
	}
}

Tabs.TabPane = AntTabs.TabPane;

export default Tabs;
